import * as React from 'react';
import bem from 'utils/bem';

export const block = bem('file-uploader');

export const getSupportedFormatsInText = (supportedFormats: string[]) => {
  const formats = supportedFormats
    .map(format => format.replace(/\./g, ''))
    .map(format => format.toUpperCase());

  if (formats.length === 1) return `${formats[0]} file`;

  if (formats.length === 2) {
    return (
      <>
        {formats.slice(0, formats.length - 1).join(', ')}
        <span> or </span>
        {formats[formats.length - 1]}
      </>
    );
  }

  return formats.join(', ');
};

export const getSupportedFileMaxInfoInText = (
  maxFileSizeInMb: number = undefined,
  additionalRestrictions: string = undefined,
) => {
  const text = [];

  if (maxFileSizeInMb) {
    text.push(`${maxFileSizeInMb / 1000}GB`);
  }

  if (additionalRestrictions) {
    text.push(additionalRestrictions);
  }

  return text.join(', ');
};
